import type { Member } from '../../entities/entityTypes';
import { requestBuilder } from '../../http/RequestBuilder';

export const useGetUserByStytchId = requestBuilder.query<
    Member,
    { stytchId: string }
>({
    endpoint: ({ stytchId }) =>
        `/api/admin/users/stytch/${encodeURIComponent(stytchId)}`,
    queryKey: ({ stytchId }) => `getUserByStytchId/${stytchId}`,
});
